const body = document.body;

// OBSERVER FOR PAYPAL ACTIONS CART & MINICART--- 
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (
        node.nodeType === 1 &&
        node.classList.contains('paypal-checkout-sandbox')
      ) {
        const active = document.activeElement;

        if (active) {
          const isInMiniCart = active.closest('.paypal-cart-button-minicart');
          if (!isInMiniCart) {
            fastCheckout('paypal', 'shoppingbag');
          } else {
            fastCheckout('paypal', 'minicart');
          }
        }
      }
    });
  });
});

observer.observe(body, {
  childList: true,
  subtree: true
});

// EVENTS FOR APPLE PAY ACTIONS PDP & CART
body.addEventListener('click', function (event) {

  if (event.target.closest('.apple-pay-pdp-button')) {
    fastCheckout('applepay', 'pdp');
  }

  if (event.target.closest('.apple-pay-cart-button')) {
    fastCheckout('applepay', 'shoppingbag');
  }

});

// -------- FAST CHECKOUT EVENT DISPATCH

function fastCheckout(cartType, buttonPosition) {
  var fastCheckoutUrl = $(".track-fast-checkout-url").val();
  var fastCheckoutData = cartType + '_fast_' + buttonPosition;
  if(fastCheckoutUrl) {
    $.ajax({
      url: fastCheckoutUrl,
      method: 'GET',
      dataType: 'json',
      data: { fastPayment: fastCheckoutData},
      success: function (data) {
        $('body').trigger('checkout:fastCheckoutStart', [cartType, buttonPosition]);
      }
  });
 }
}